import React, { useState, useImperativeHandle } from "react";
import Turnstile, { useTurnstile } from "react-turnstile";

interface TurnstileCaptchaProps {
  siteKey: string;
  onVerify: (token: string) => void;
  onError?: (error: Error) => void;
  onExpire?: () => void;
  onUnsupported?: () => void;
}

export interface TurnstileCaptchaRef {
  reset: () => void;
}

const TurnstileCaptcha = React.forwardRef<
  TurnstileCaptchaRef,
  TurnstileCaptchaProps
>(({ siteKey, onVerify, onError, onExpire, onUnsupported }, ref) => {
  const turnstile = useTurnstile();
  const [token, setToken] = useState<string | null>(null);

  useImperativeHandle(ref, () => ({
    reset: () => {
      setToken(null);
      turnstile.reset();
    },
  }));

  return (
    <Turnstile
      sitekey={siteKey}
      refreshExpired="auto"
      theme="light"
      onVerify={token => {
        setToken(token);
        onVerify(token);
      }}
      onError={error => {
        console.error("ERROR - Captcha failed (" + error + ").");
        if (onError) {
          onError(error);
        }
      }}
      onExpire={() => {
        setToken(null);
        turnstile.reset();
        if (onExpire) {
          onExpire();
        }
      }}
      onUnsupported={() => {
        console.error("ERROR - Captcha unsupported by browser.");
        if (onUnsupported) {
          onUnsupported();
        }
      }}
    />
  );
});

export default TurnstileCaptcha;
